import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tutorial-profile',
  templateUrl: './tutorial-profile.component.html',
  styleUrls: ['./tutorial-profile.component.css']
})
export class TutorialProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}